module.exports = __webpack_public_path__ + "static/media/check-icon.b78cc1a8.svg";